import Vue from 'vue'
import Router from 'vue-router'
import miss from '@/pages/miss'
import main from '@/pages/main'
import home from '@/pages/home'
import login from '@/pages/login'
import duanxin from '@/pages/duanxin/duanxin'
import duanxinmob from '@/pages/duanxin/duanxinmob'
import chongzhi from '@/pages/duanxin/chongzhi'
import duanxinfasong from '@/pages/duanxin/duanxinfasong'
import fasongjl from '@/pages/duanxin/fasongjl'
import chongzhijl from '@/pages/duanxin/chongzhijl'
import huiyuan from '@/pages/huiyuan/huiyuan'
import huiyuanmd from '@/pages/huiyuan/huiyuanmd'
import paikejl from '@/pages/paike/paikejl'
import paike_print from '@/pages/paike/paike_print'
import paike from '@/pages/paike/paike'
import paikexiu from '@/pages/paike/paikexiu'

// import huiyuanx from '@/pages/huiyuan/huiyuanx'
import huiyuanx from '@/pages/huiyuan/huiyuanx2'
import huiyuanxin from '@/pages/huiyuan/huiyuanxin'
// import huiyuanqianxin from '@/pages/huiyuan/huiyuanqianxin'
import add_con from '@/pages/huiyuan/add_con'
import show_con from '@/pages/huiyuan/show_con'
// import tuoyuqianyue from '@/pages/huiyuan/tuoyuqianyue_newversion'
// import show_tuoyu_con from '@/pages/huiyuan/show_tuoyu_con_newversion'
// import tuoyuqynew from '@/pages/huiyuan/tuoyuqianyue_newversion'
// import show_tuoyu_con_new from '@/pages/huiyuan/show_tuoyu_con_newversion'
import qiandao from '@/pages/qiandao/qiandao'
import printing from '@/pages/qiandao/printing'
import huiyuanxiu from '@/pages/huiyuan/huiyuanxiu'
import buqian from '@/pages/qiandao/buqian'
import xiaofei from '@/pages/qiandao/xiaofei'
import yuangs from '@/pages/xitong/yuangs'
import jiaoshi from '@/pages/xitong/jiaoshi'
import youhui from '@/pages/xitong/youhui'
import kechengs from '@/pages/xitong/kechengs'
import shangpins from '@/pages/xitong/shangpins'
import mima from '@/pages/xitong/mima'
import heyue from '@/pages/heyue/heyue'
import jiaoan from '@/pages/jiaoan/jiaoan'
import jiaoanx from '@/pages/jiaoan/jiaoanx'
import jiaoanx2 from '@/pages/jiaoan/jiaoanx2'
import jiaoan3 from '@/pages/jiaoan/jiaoan3'
import jiaoan4 from '@/pages/jiaoan/jiaoan4'
import huiben from '@/pages/huiben/huiben'
// 预约
import yuyue from '@/pages/yuyue/yuyue'
//潜客跟进
import Qianke from '@/pages/genjin/qianke'
import fenxi from '@/pages/genjin/fenxi'
import Gendan from '@/pages/genjin/gendan'
import Vip from '@/pages/genjin/vip'
import Insert from '@/pages/genjin/insert'
import Minuta from '@/pages/genjin/minuta'
import Follow from '@/pages/genjin/follow'
import Yuexinzengmd from '@/pages/genjin/yuexinzengmd'
import Yuegenjinjl from '@/pages/genjin/yuegenjinjl'
import Mingdanzs from '@/pages/genjin/mingdanzs'
import Hetongs from '@/pages/genjin/hetongs'
import Hetongje from '@/pages/genjin/hetongje'
import Qwangqigj from '@/pages/genjin/qwangqigj'
import Qjinjigj from '@/pages/genjin/qjinjigj'
import Qjinrigj from '@/pages/genjin/qjinrigj'
import Qjinrixz from '@/pages/genjin/qjinrixz'
import Vjinjigj from '@/pages/genjin/vjinjigj'
import Vwangqigj from '@/pages/genjin/vwangqigj'
import Vjinrigj from '@/pages/genjin/Vjinrigj'
import Vjinrixz from '@/pages/genjin/Vjinrixz'
import caidan from '@/pages/genjin/caidan'
import wuxiao from '@/pages/genjin/wuxiao'
import chongzhim from '@/pages/chongzhim'
import geren from '@/pages/geren'
import select_class from '@/pages/xuanke/select_class'
import look_class from '@/pages/xuanke/look_class'
//耗课
import haoke1 from '@/pages/haoke/haoke1'
import xzjl from '@/pages/haoke/xzjl'
//进销存

import shanglei from '@/pages/jinxc/shanglei'
import gongys from '@/pages/jinxc/gongys'
import shangx from '@/pages/jinxc/shangx'
import wuliu from '@/pages/jinxc/wuliu'
import churukl from '@/pages/jinxc/churukl'
import rizhi from '@/pages/jinxc/rizhi'
import rukgl from '@/pages/jinxc/rukgl'
import chukgl from '@/pages/jinxc/chukgl'
import kcshanglei from '@/pages/jinxc/kcshanglei'
import kcbaobiao from '@/pages/jinxc/kcbaobiao'
import kcpand from '@/pages/jinxc/kcpand'
import kcchuru from '@/pages/jinxc/kcchuru'

//活动部分
//活动部分s
import actlie from '@/pages/huodong/actlie'
import actdetail from '@/pages/huodong/actdetail'
import hdshouye from '@/pages/huodong/hdshouye'
import hdshezhi from '@/pages/huodong/hdshezhi'
import wqhd from '@/pages/huodong/wqhd'
import fangkui from '@/pages/huodong/fangkui'
import fangcha from '@/pages/huodong/fangcha'
//测评s
import actset from '@/pages/ceping/actset'
import yinxiaolie from '@/pages/ceping/yixiaolie'
import cepinyu from '@/pages/ceping/cepingyu'
import actjiesuan from '@/pages/ceping/actjiesuan'
import caiwu from '@/pages/ceping/centercaiwu'
import renjies from '@/pages/ceping/renjies'
import yewujsuan from '@/pages/ceping/yewujsuan'
import actxiang from '@/pages/ceping/actxiang'
import datiyelc from '@/pages/ceping/datiyelc'
import historylc from '@/pages/ceping/historylc'
import cepingxlc from '@/pages/ceping/cepingxlc'
import cpaddmeslc from '@/pages/ceping/cpaddmeslc'
import newlist from '@/pages/ceping/newlist'
import yuyuelie from '@/pages/ceping/yuyuelie'
import yewujiesuan2 from '@/pages/ceping/yewujiesuan2'

//系统合约项目
import xinjianheyue from '@/pages/xitong/xinjianheyue'
import xinjianhetong from '@/pages/xitong/xinjianhetong'

// 积分管理
import shenhe from '@/pages/jifen/shenhe'
import shezhi from '@/pages/jifen/shezhi'
import shenqing from '@/pages/jifen/shenqing'
import kaohe from '@/pages/jifen/kaohe'
import shuju from '@/pages/jifen/shuju'
import gerenjilu from '@/pages/jifen/gerenjilu'

//教具衍生品
import yanshengpin from '@/pages/jiaoju/yanshengpin'
import jiaojuye from '@/pages/jiaoju/jiaojuye'
import dingdanlie from '@/pages/jiaoju/dingdanlie'
import wuziye from '@/pages/jiaoju/wuziye'

//测评e
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '*',
      component: miss,
    },
    {
      path: '/show_con',
      name: 'show_con',
      component: show_con,
    },
    // {
    //   path: '/show_tuoyu_con',
    //   name: 'show_tuoyu_con',
    //   component: show_tuoyu_con,
    //   meta: {auth: true}
    // },
    // {
    //   path: '/show_tuoyu_con_new',
    //   name: 'show_tuoyu_con_new',
    //   component: show_tuoyu_con_new,
    //   meta: {auth: true}
    // },
    {
      path: '/printing',
      name: 'printing',
      component: printing,
    },
    {
      path: '/',
      name: 'main',
      component: main,
      children: [
        //教具
        {
          path: '/jiaojuye',
          name: 'jiaojuye',
          component: jiaojuye,
          meta: {auth: true}
        },
        //衍生品
        {
          path: '/yanshengpin',
          name: 'yanshengpin',
          component: yanshengpin,
          meta: {auth: true}
        },
        //衍生品订单页面
        {
          path: '/dingdanlie',
          name: 'dingdanlie',
          component: dingdanlie,
          meta: {auth: true}
        },
        //物资页
        {
          path: '/wuziye',
          name: 'wuziye',
          component: wuziye,
          meta: {auth: true}
        },
        //合约项目
        {
          path: '/xinjianheyue',
          name: 'xinjianheyue',
          component: xinjianheyue,
          meta: {auth: true}
        },
        {
          path: '/xinjianhetong',
          name: 'xinjianhetong',
          component: xinjianhetong,
          meta: {auth: true}
        },
        // {
        //   path: '/',
        //   name: 'follow',
        //   component: Follow,
        //   meta: {auth: true}
        // },
        // {
        //     path: '/indexpc',
        //     name: 'follow',
        //     component: Follow,
        //     meta:{auth:true}
        // },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta: {auth: true}
        },
        {
          path: '/geren',
          name: 'geren',
          component: geren,
          meta: {auth: true}
        },
        {
          path: '/duanxin',
          name: 'duanxin',
          component: duanxin,
          meta: {auth: true}
        },
        {
          path: '/qianke',
          name: 'qianke',
          component: Qianke,
          meta: {auth: true}
        },
        {
          path: '/fenxi',
          name: 'fenxi',
          component: fenxi,
          meta: {auth: true}
        },
        {
          path: '/gendan',
          name: 'gendan',
          component: Gendan,
          meta: {auth: true}
        },
        {
          path: '/vip',
          name: 'vip',
          component: Vip,
          meta: {auth: true}
        },
        {
          path: '/insert',
          name: 'insert',
          component: Insert,
          meta: {auth: true}
        },
        {
          path: '/minuta',
          name: 'minuta',
          component: Minuta,
          meta: {auth: true}
        },
        {
          path: '/follow',
          name: 'follow',
          component: Follow,
          meta: {auth: true}
        },
        {
          path: '/yuexinzengmd',
          name: 'yuexinzengmd',
          component: Yuexinzengmd,
          meta: {auth: true}
        },
        {
          path: '/yuegenjinjl',
          name: 'yuegenjinjl',
          component: Yuegenjinjl,
          meta: {auth: true}
        },
        {
          path: '/mingdanzs',
          name: 'mingdanzs',
          component: Mingdanzs,
          meta: {auth: true}
        },
        {
          path: '/hetongs',
          name: 'hetongs',
          component: Hetongs,
          meta: {auth: true}
        },
        {
          path: '/hetongje',
          name: 'hetongje',
          component: Hetongje,
          meta: {auth: true}
        },
        {
          path: '/paike',
          name: 'paike',
          component: paike,
          meta: {auth: true}

        },
        {
          path: '/paikejl',
          name: 'paikejl',
          component: paikejl,
          meta: {auth: true}
        },
        {
          path: '/paike_print',
          name: 'paike_print',
          component: paike_print,
          meta: {auth: true}
        },
        {
          path: '/paikexiu',
          name: 'paikexiu',
          component: paikexiu,
          meta: {auth: true}
        },
        {
          path: '/qjinjigj',
          name: 'qjinjigj',
          component: Qjinjigj,
          meta: {auth: true}

        },
        {
          path: '/vjinjigj',
          name: 'vjinjigj',
          component: Vjinjigj,
          meta: {auth: true}
        },
        {
          path: '/qjinrigj',
          name: 'qjinrigj',
          component: Qjinrigj,
          meta: {auth: true}
        },
        {
          path: '/qwangqigj',
          name: 'qwangqigj',
          component: Qwangqigj,
          meta: {auth: true}
        },
        {
          path: '/qjinrixz',
          name: 'qjinrixz',
          component: Qjinrixz,
          meta: {auth: true}
        },
        {
          path: '/vjinrigj',
          name: 'vjinrigj',
          component: Vjinrigj,
          meta: {auth: true}
        },
        {
          path: '/vwangqigj',
          name: 'vwangqigj',
          component: Vwangqigj,
          meta: {auth: true}
        },
        {
          path: '/vjinrixz',
          name: 'vjinrixz',
          component: Vjinrixz,
          meta: {auth: true}
        },
        {
          path: '/caidan',
          name: 'caidan',
          component: caidan,
          meta: {auth: true}
        },
        {
          path: '/wuxiao',
          name: 'wuxiao',
          component: wuxiao,
          meta: {auth: true}
        },
        {
          path: '/heyue',
          name: 'heyue',
          component: heyue,
          meta: {auth: true}
        },
        {
          path: '/huiben',
          name: 'huiben',
          component: huiben,
          meta: {auth: true}
        },
        {
          path: '/jiaoanx',
          name: 'jiaoanx',
          component: jiaoanx,
          meta: {auth: true}
        },
        {
          path: '/jiaoanx2',
          name: 'jiaoanx2',
          component: jiaoanx2,
          meta: {auth: true}
        },
        {
          path: '/jiaoan3',
          name: 'jiaoan3',
          component: jiaoan3,
          meta: {auth: true}
        },
        {
          path: '/jiaoan4',
          name: 'jiaoan4',
          component: jiaoan4,
          meta: {auth: true}
        },
        {
          path: '/kechengs',
          name: 'kechengs',
          component: kechengs,
          meta: {auth: true}
        },
        {
          path: '/mima',
          name: 'mima',
          component: mima,
          meta: {auth: true}
        },
        {
          path: '/yuangs',
          name: 'yuangs',
          component: yuangs,
          meta: {auth: true}
        },
        {
          path: '/jiaoshi',
          name: 'jiaoshi',
          component: jiaoshi,
          meta: {auth: true}
        },
          {
              path: '/youhui',
              name: 'youhui',
              component: youhui,
              meta: {auth: true}
          },
        {
          path: '/qiandao',
          name: 'qiandao',
          component: qiandao,
          meta: {auth: true}
        },
        {
          path: '/shangpins',
          name: 'shangpins',
          component: shangpins,
          meta: {auth: true}
        },

        {
          path: '/huiyuanx',
          name: 'huiyuanx',
          component: huiyuanx,
          meta: {auth: true}
        },
        {
          path: '/huiyuanmd',
          name: 'huiyuanmd',
          component: huiyuanmd,
          meta: {auth: true}
        },
        {
          path: '/jiaoan',
          name: 'jiaoan',
          component: jiaoan,
          meta: {auth: true}
        },
        {
          path: '/buqian',
          name: 'buqian',
          component: buqian,
          meta: {auth: true}
        },
        {
          path: '/xiaofei',
          name: 'xiaofei',
          component: xiaofei,
          meta: {auth: true}
        },
        {
          path: '/fasongjl',
          name: 'fasongjl',
          component: fasongjl,
          meta: {auth: true}
        },
        {
          path: '/chongzhijl',
          name: 'chongzhijl',
          component: chongzhijl,
          meta: {auth: true}
        },
        {
          path: '/huiyuanxiu',
          name: 'huiyuanxiu',
          component: huiyuanxiu,
          meta: {auth: true}
        },
        {
          path: '/huiyuan',
          name: 'huiyuan',
          component: huiyuan,
          meta: {auth: true}
        },

        {
          path: '/huiyuanxin',
          name: 'huiyuanxin',
          component: huiyuanxin,
          meta: {auth: true}
        },
        {
          path: '/add_con',
          name: 'add_con',
          component: add_con,
          meta: {auth: true}
        },
        // {
        //   path: '/huiyuanqianxin',
        //   name: 'huiyuanqianxin',
        //   component: huiyuanqianxin,
        //   meta: {auth: true}
        // },
        // {
        //   path: '/tuoyuqianyue',
        //   name: 'tuoyuqianyue',
        //   component: tuoyuqianyue,
        //   meta: {auth: true}
        // },
        // {
        //   path: '/tuoyuqynew',
        //   name: 'tuoyuqynew',
        //   component: tuoyuqynew,
        //   meta: {auth: true}
        // },
        // {
        //     path: '/show_tuoyu_con',
        //     name: 'show_tuoyu_con',
        //     component: show_tuoyu_con,
        //     meta:{auth:true}
        // },
        // {
        //     path: '/show_con',
        //     name: 'show_con',
        //     component: show_con,
        //     meta:{auth:true}
        // },
        {
          path: '/chongzhi',
          name: 'chongzhi',
          component: chongzhi,
          meta: {auth: true}
        },
        {
          path: '/duanxinfasong',
          name: 'duanxinfasong',
          component: duanxinfasong,
          meta: {auth: true}
        },
        {
          path: '/duanxinmob',
          name: 'duanxinmob',
          component: duanxinmob,
          meta: {auth: true}
        },
        {
          path: '/select_class',
          name: 'select_class',
          component: select_class,
          meta: {auth: true}
        },
        {
          path: '/look_class',
          name: 'look_class',
          component: look_class,
          meta: {auth: true}
        },
        //进销存s
        {
          path: '/shanglei',
          name: 'shanglei',
          component: shanglei,
          meta: {auth: true}
        },
        {
          path: '/gongys',
          name: 'gongys',
          component: gongys,
          meta: {auth: true}
        },
        {
          path: '/shangx',
          name: 'shangx',
          component: shangx,
          meta: {auth: true}
        },
        {
          path: '/wuliu',
          name: 'wuliu',
          component: wuliu,
          meta: {auth: true}
        },
        {
          path: '/churukl',
          name: 'churukl',
          component: churukl,
          meta: {auth: true}
        },
        {
          path: '/rizhi',
          name: 'rizhi',
          component: rizhi,
          meta: {auth: true}
        },
        {
          path: '/rukgl',
          name: 'rukgl',
          component: rukgl,
          meta: {auth: true}
        },
        {
          path: '/chukgl',
          name: 'chukgl',
          component: chukgl,
          meta: {auth: true}
        },
        {
          path: '/kcshanglei',
          name: 'kcshanglei',
          component: kcshanglei,
          meta: {auth: true}
        },
        {
          path: '/kcbaobiao',
          name: 'kcbaobiao',
          component: kcbaobiao,
          meta: {auth: true}
        },
        {
          path: '/kcpand',
          name: 'kcpand',
          component: kcpand,
          meta: {auth: true}
        },
        {
          path: '/kcchuru',
          name: 'kcchuru',
          component: kcchuru,
          meta: {auth: true}
        },
        //进销存e
        {
          path: '/haoke1',
          name: 'haoke1',
          component: haoke1,
          meta: {auth: true}
        },
        {
          path: '/xzjl',
          name: 'xzjl',
          component: xzjl,
          meta: {auth: true}
        },
        //活动s
        {
          path: '/actlie',
          name: 'actlie',
          component: actlie,
          meta: {auth: true}
        },
        {
          path: '/actdetail',
          name: 'actdetail',
          component: actdetail,
          meta: {auth: true}
        },
        {
          path: '/hdshouye',
          name: 'hdshouye',
          component: hdshouye,
          meta: {auth: true}
        },
        {
          path: '/hdshezhi',
          name: 'hdshezhi',
          component: hdshezhi,
          meta: {auth: true}
        },
        {
          path: '/wqhd',
          name: 'wqhd',
          component: wqhd,
          meta: {auth: true}
        },
        {
          path: '/fangkui',
          name: 'fangkui',
          component: fangkui,
          meta: {auth: true}
        },
        {
          path: '/fangcha',
          name: 'fangcha',
          component: fangcha,
          meta: {auth: true}
        },
        //活动e
        //测评s
        // 测评s
        {
          path: '/actset',
          name: 'actset',
          component: actset,
          meta: {auth: true}
        },

        {
          path: '/yinxiaolie',
          name: 'yinxiaolie',
          component: yinxiaolie,
          meta: {auth: true}
        },
        {
          path: '/cepinyu',
          name: 'cepinyu',
          component: cepinyu,
          meta: {auth: true}
        },

        {
          path: '/actjiesuan',
          name: 'actjiesuan',
          component: actjiesuan,
          meta: {auth: true}
        },
        {
          path: '/caiwu',
          name: 'caiwu',
          component: caiwu,
          meta: {auth: true}
        },
        {
          path: '/renjies',
          name: 'renjies',
          component: renjies,
          meta: {auth: true}
        },
        {
          path: '/yewujsuan',
          name: 'yewujsuan',
          component: yewujsuan,
          meta: {auth: true}
        },
        {
          path: '/actxiang',
          name: 'actxiang',
          component: actxiang,
          meta: {auth: true}
        },
        {
          path: '/datiyelc',
          name: 'datiyelc',
          component: datiyelc,
          meta: {auth: true}
        },
        {
          path: '/historylc',
          name: 'historylc',
          component: historylc,
          meta: {auth: true}
        },
        {
          path: '/cepingxlc',
          name: 'cepingxlc',
          component: cepingxlc,
          meta: {auth: true}
        },
        {
          path: '/cpaddmeslc',
          name: 'cpaddmeslc',
          component: cpaddmeslc,
          meta: {auth: true}
        },
        {
          path: '/newlist',
          name: 'newlist',
          component: newlist,
          meta: {auth: true}
        },
        {
          path: '/yuyuelie',
          name: 'yuyuelie',
          component: yuyuelie,
          meta: {auth: true}
        },
        {
          path: '/yewujiesuan2',
          name: 'yewujiesuan2',
          component: yewujiesuan2,
          meta: {auth: true}
        },

        // 测评e
        // 积分管理
        {
          path: '/shenhe',
          name: 'shenhe',
          component: shenhe,
          meta: {auth: true}
        },
        {
          path: '/shezhi',
          name: 'shezhi',
          component: shezhi,
          meta: {auth: true}
        },
        {
          path: '/shenqing',
          name: 'shenqing',
          component: shenqing,
          meta: {auth: true}
        },
        {
          path: '/kaohe',
          name: 'kaohe',
          component: kaohe,
          meta: {auth: true}
        },
        {
          path: '/shuju',
          name: 'shuju',
          component: shuju,
          meta: {auth: true}
        },
        {
          path: '/gerenjilu',
          name: 'gerenjilu',
          component: gerenjilu,
          meta: {auth: true}
        },
        // 预约
        {
          path: '/yuyue',
          name: 'yuyue',
          component: yuyue,
          meta: {auth: true}
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/chongzhim',
      name: 'chongzhim',
      component: chongzhim,
    },


  ]


})



// WEBPACK FOOTER //
// ./src/router/index.js